import { PropsWithChildren, useEffect, useState } from 'react';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import { CheckCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import { AuthFormProps } from '../types';
// import useTranslation from 'providers/i18n/hooks/useTranslation';
import Typography from 'components/commercetools-ui/atoms/typography';
import Icon from 'components/icons/x-mark';
import FeedbackIconLayer from 'components/commercetools-ui/atoms/button/feedbackIconLayer';
import Spinner from '../../spinner';

const AuthForm = ({
  title,
  headTitle,
  subtitle,
  subtitleLink,
  subtitleLinkLabel,
  subtitleLinkClickEvent,
  buttonLabel,
  error,
  success,
  includeCheckIcon,
  onSubmit,
  resetting,
  loading,
  children,
  resetCallback,
  onClose,
  handleModalCancel
}: PropsWithChildren<AuthFormProps>) => {
  // const { translate } = useTranslation();

  const sendReset = () => {
    resetCallback(false);
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    if (handleModalCancel) {
      handleModalCancel();
    }
    return;
  };
  return (
    <>
      <div className="mb-20 flex items-center">
        <Typography className="flex flex-1 justify-center !text-20 !text-[090909]">{headTitle}</Typography>
        <div className="cursor-p" onClick={handleClose}>
          <Icon />
        </div>
      </div>
      <div className="mb-40 h-1 w-full !bg-[#999]"></div>
      <div className="flex items-center justify-center">
        {includeCheckIcon && <CheckCircleIcon className="text-primary h-6 w-6" />}

        <Typography
          as="h1"
          className="text-gray xs:text-xl text-center font-medium md:text-3xl lg:text-3xl"
          style={{ color: '#090909', fontWeight: '500' }}
        >
          {title}
        </Typography>
      </div>
      {children && (
        <div className="mt-20 grid gap-20">
          {success && (
            <div className='flex items-center !gap-12 justify-center'>
              <InformationCircleIcon className="h-24 w-24 cursor-default text-green-600 stroke-green-600 " />{' '}
              <Typography className="text-green-600 text-16 font-medium">{success}</Typography>
            </div>
          )}
          {error && <Typography className=" !text-12 font-normal text-[#E32C53]">{error}</Typography>}
          {children}
        </div>
      )}
      <Button
        className={`relative !my-20 h-44 w-full cursor-pointer rounded-none !bg-gray-700 !px-25 !py-13 text-center text-14 disabled:cursor-auto disabled:!bg-gray-400`}
        disabled={!!error || loading}
        onClick={onSubmit}
      >
        {buttonLabel}
      </Button>

      {subtitle && (
        <div className="flex flex-row !items-center !justify-center !gap-4">
          <Typography className="!text-center !text-14 !leading-loose !text-gray-600">{subtitle}</Typography>
          {subtitleLink && subtitleLinkLabel && (
            <Link
              className="!w-fit text-center !text-14 !font-medium leading-loose !text-gray-600 !underline underline-offset-4 hover:!text-gray-500"
              link={'#'}
              onClick={subtitleLinkClickEvent}
              preFetch={true}
            >
              {subtitleLinkLabel}
            </Link>
          )}
        </div>
      )}
      {/* {resetting && (
        <>
          <div className="mt-4 flex justify-center no-underline">
            <Typography className="text-center text-gray-600">{translate('account.account.doNotHave')}</Typography>

            <Link className="ml-1 text-14 text-gray-600 underline hover:text-gray-500" link="/register">
              {translate('account.account.register.link')}
            </Link>
          </div>
          <div className="mt-5 flex justify-center no-underline">
            <Typography className="text-center text-gray-600">{translate('account.account.alreadyHave')}</Typography>

            <Link
              className="ml-1 text-14 text-gray-600 underline hover:text-gray-500"
              link="/login"
              onClick={() => sendReset()}
            >
              {translate('account.account.loginHere')}
            </Link>
          </div>
        </>
      )} */}
       {
        loading && <Spinner />
      }
    </>
  );
};

export default AuthForm;
